import React from 'react'
import { AdminPageWrapper, BuildingData, PageHeader, TCancelButton } from 'components'
import { useHistory, useLocation } from 'react-router-dom'

const CreateEditBuilding = () => {
  const location = useLocation()
  const history = useHistory()

  const {
    state: {
      _id
    }
  } = location

  const RightContent = () => (
    <TCancelButton
      onClick={() => history.goBack()}
    >
      Back
    </TCancelButton>
  )

  return (
    <>
      <PageHeader
        title={`${_id ? 'Editing' : 'Creating new'} building`}
        rightContent={<RightContent />}
      />
      <AdminPageWrapper>
        <BuildingData
          _id={_id}
        />
      </AdminPageWrapper>
    </>
  )
}

export default CreateEditBuilding
